import { mapState } from "vuex";

import {
  GET_EVENTS_COLLECTION,
} from "@/store/events/actions";

export default {
  methods: {
    async getEvents() {
      if (this.$cannot('VIEW_EVENTS')) {
        return;
      }
      
      let from = this.filters.date ? this.filters.date : this.$moment().format('YYYY-MM-DD');

      await this.$store.dispatch(GET_EVENTS_COLLECTION, {
        range: {
          start_date: from,
          end_date: this.$moment(from).add(this.filters.days, 'days').format('YYYY-MM-DD')
        }
      });
    },
    dayHasEvent(date) {
      return this.events.find(item => {
        return this.$isDateBetween(date, {
          start_date: item.start_date,
          end_date: item.end_date
        })
      });
    },
    getDayEvent(date) {
      let events = this.events.filter(item => {
        return this.$isDateBetween(date, {
          start_date: item.start_date,
          end_date: item.end_date
        })
      });

      if (!events || !events.length) {
        return false;
      }

      let eventName = '';

      events.forEach(item => {
        eventName += `| ${item.name} |`;
      });

      return {
        color: events.length === 1 ? this.getEventColor(events) : 'white',
        text: eventName,
      }
    },
    getEventColor(events) {
      if (events[0].relevance === this.$const('ConstEventsRelevance', 'LOW')) return 'green';
      if (events[0].relevance === this.$const('ConstEventsRelevance', 'MEDIUM')) return 'warning';
      if (events[0].relevance === this.$const('ConstEventsRelevance', 'HIGH')) return 'red';

      return 'white';
    }
  },
  computed: {
    filters: {
      get() {
        return this.settings;
      },
      set() {}
    },
    ...mapState({
      settings: state => state.calendarSettings.current,
      events: state => state.events.getCollectionRequest.collection,
    }),
  },
}
